'use client';

import { AuthGuard } from '@modules/auth/components/AuthGuard/AuthGuard';
import { GlobalAccessCache } from '@modules/auth/providers/GlobalAccessCache/GlobalAccessCache';
import { CopilotScript } from '@modules/copilot/components/CopilotScript/CopilotScript';
import { VideoModalProvider } from 'app/(authenticated)/organizations/[organizationId]/learning/VideoModal';
import { HealthCheckListener } from 'app/_components/HealthCheckListener';
import { GlobalAccessProvider } from 'app/_providers/GlobalAccessProvider';
import { OrganizationProvider } from 'app/_providers/Organization';
import { RedirectProvider } from 'app/_providers/RedirectProvider/RedirectProvider';
import { UserProvider } from 'app/_providers/User';
import { WorkspaceProvider } from 'app/_providers/WorkspaceProvider';

import React from 'react';

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => (
  <AuthGuard>
    <UserProvider>
      <HealthCheckListener appName='CloudPortal' />
      <GlobalAccessProvider>
        <GlobalAccessCache>
          <OrganizationProvider>
            <WorkspaceProvider>
              <VideoModalProvider>
                <RedirectProvider>{children}</RedirectProvider>
              </VideoModalProvider>

              <CopilotScript />
            </WorkspaceProvider>
          </OrganizationProvider>
        </GlobalAccessCache>
      </GlobalAccessProvider>
    </UserProvider>
  </AuthGuard>
);

export default Layout;
